import { useWidgetData } from '../../../context/widgetDataContext';
import { PackageContextState, PackagePreloadedState } from '../types';
import { useMemo } from 'react';
import { get } from 'lodash';
import { useGetApiClient } from '../../../context/apiContext/hooks/useGetApiClient';
import { RequestState, useRequestState } from '../../../hooks';
import { mapPackageToPackageContextState } from '../utils/index';

export const useGetPackageData = () => {
  const api = useGetApiClient();
  const { setRequestState } = useRequestState();
  const { data, setData } = useWidgetData<
    undefined | PackagePreloadedState | PackageContextState
  >();

  const getPackageData = async () => {
    setRequestState(RequestState.LOADING);

    if (!data?.package_id || !api) {
      setRequestState(RequestState.ERROR);
      return;
    }

    if (!data['package']) {
      try {
        const packageDataResponse = await api.getPackagesShow({
          package_id: data.package_id,
        });

        const packageData = mapPackageToPackageContextState(packageDataResponse, data);

        setData(packageData);
        setRequestState(RequestState.SUCCESS);

        return get(packageData, ['package']);
      } catch (e) {
        console.log('Error', e, data);
        setRequestState(RequestState.ERROR);
      }
    }

    return get(data, ['package']);
  };

  const packageData = useMemo(() => get(data, ['package']), [data]);

  return {
    getPackageData,
    packageData,
  };
};
